import React from 'react';
import { tasia2 } from '../../../../assets/images';
import Image from 'next/image';

interface AskCsIcon2Props {
  width?: number | `${number}`;
  height?: number | `${number}`;
}

const AskCsIcon2 = ({ width = '19', height = '19' }: AskCsIcon2Props) => {
  return <Image height={height} width={width} src={tasia2.src} alt="ask tasia" />;
};

export default AskCsIcon2;
